import { Filter } from '@cubejs-client/core';
import { useCubeQuery } from '@cubejs-client/react';
import { renameKeys } from '@procureai/util';
import { isNotEmpty } from 'ramda';
import { useParams } from 'react-router-dom';

import { SourcingProjectField, SourcingProjectData } from '~/common/types/cubes/SourcingProject';

const dimToKeyMap: Record<SourcingProjectField, keyof SourcingProjectData> = {
  [SourcingProjectField.ID]: 'id',
  [SourcingProjectField.TITLE]: 'title',
  [SourcingProjectField.STATUS]: 'status',
  [SourcingProjectField.VARIANT]: 'variant',
  [SourcingProjectField.STARTED_AT]: 'startedAt',
  [SourcingProjectField.COMMODITY_GROUP_ID]: 'commodityGroupId',
  [SourcingProjectField.ESTIMATED_TOTAL_VALUE]: 'estimatedTotalValue',
  [SourcingProjectField.BUYER_ID]: 'buyerId',
  [SourcingProjectField.CURRENCY]: 'currency',
};

const stripDimPrefix = renameKeys(dimToKeyMap);

export const useSourcingProjectInformation = () => {
  const { sourcingProjectId } = useParams() as { sourcingProjectId: string };
  const filters: Filter[] = [
    {
      member: SourcingProjectField.ID,
      operator: 'equals',
      values: [sourcingProjectId],
    },
  ];
  const query = {
    dimensions: [
      SourcingProjectField.ID,
      SourcingProjectField.TITLE,
      SourcingProjectField.STATUS,
      SourcingProjectField.STARTED_AT,
      SourcingProjectField.VARIANT,
      SourcingProjectField.COMMODITY_GROUP_ID,
      SourcingProjectField.ESTIMATED_TOTAL_VALUE,
      SourcingProjectField.CURRENCY,
      SourcingProjectField.BUYER_ID,
    ],
    filters,
  };

  const { isLoading, resultSet } = useCubeQuery({
    ...query,
  });

  const rawData = resultSet?.rawData() ?? [];

  const sourcingProjectData: SourcingProjectData = isNotEmpty(rawData)
    ? stripDimPrefix(rawData[0])
    : {
        id: sourcingProjectId,
      };

  return {
    isLoading,
    sourcingProjectData,
  };
};
